import { Outlet } from 'react-router-dom';

import { CustomerProvider } from 'contexts';
import { FC } from 'react';
import { DamageOptionProvider } from './damage-options';
import { LookupProvider } from './lookups';
import { ResponseProvider } from './response';
import { SelectedLocationProvider } from './selected-location';
import { SizeTypeProvider } from './size-types';
import { TemplatesProvider } from './templates';

const ProviderWrapper: FC = () => (
  <CustomerProvider>
    <SelectedLocationProvider>
      <ResponseProvider>
        <TemplatesProvider>
          <DamageOptionProvider>
            <LookupProvider>
              <SizeTypeProvider>
                <Outlet />
              </SizeTypeProvider>
            </LookupProvider>
          </DamageOptionProvider>
        </TemplatesProvider>
      </ResponseProvider>
    </SelectedLocationProvider>
  </CustomerProvider>
);

export default ProviderWrapper;
